module.exports = __webpack_public_path__ + "img/logrono.7cce4abc.jpg";